import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export class Step extends Vue {
    @Prop({ default: 0 }) $_step: number;
    @Prop({ default: true }) $_normal: boolean;
    @Prop({ default: false }) $_warning: boolean;
    @Prop() $_warningMessage: string;

    @Emit()
    $_nextStep(step: number) {}

    @Emit()
    $_backStep(step: number) {}

    @Emit()
    $_finishStep() {}

    @Emit()
    $_cancelStep() {}

    @Emit()
    $_confirmCancel() {}

    @Emit()
    $_cancelConfirm() {}
}
